import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressOptionsSummaryFormUS = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['addressOptions'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const usePoBoxField = s.addressOptions.fields.find(({ name }) => name === 'usePoBox');
  const usePoBoxLabel = translate(usePoBoxField?.options?.find(({ name }) => name === 'usePoBox')?.label);
  const usePoBoxValue = getFieldValue('usePoBox')
    ? translate(eventConfig?.translations.yes)
    : translate(eventConfig?.translations.no);

  const poboxField = s.addressOptions.fields.find(({ name }) => name === 'pobox');
  const poboxLabel = translate(poboxField?.label);

  const poboxcityField = s.addressOptions.fields.find(({ name }) => name === 'poboxcity');
  const poboxcityLabel = translate(poboxcityField?.label);

  const poboxstateField = s.addressOptions.fields.find(({ name }) => name === 'poboxstate');
  const poboxstateLabel = translate(poboxstateField?.label);
  const poboxstateValue =
    translate(poboxstateField?.options?.find(({ value }) => value == getFieldValue('poboxstate'))?.label) ||
    getFieldValue('poboxstate');

  const poboxzipcodeField = s.addressOptions.fields.find(({ name }) => name === 'poboxzipcode');
  const poboxzipcodeLabel = translate(poboxzipcodeField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-address-options'}>
      <h2>{translate(s.dataSummary.titles?.pobox)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{!editMode && usePoBoxLabel}</div>
        <div className={'value'}>
          {!editMode && usePoBoxValue}
          {editMode && <EditDataField field={usePoBoxField!} slideId={'addressOptions'} />}
        </div>

        <div className={'label'}>{poboxLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('pobox')}
          {editMode && <EditDataField field={poboxField!} slideId={'addressOptions'} />}
        </div>

        <div className={'label'}>{poboxcityLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('poboxcity')}
          {editMode && <EditDataField field={poboxcityField!} slideId={'addressOptions'} />}
        </div>

        <div className={'label'}>{poboxstateLabel}</div>
        <div className={'value'}>
          {!editMode && poboxstateValue}
          {editMode && <EditDataField field={poboxstateField!} slideId={'addressOptions'} />}
        </div>

        <div className={'label'}>{poboxzipcodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('poboxzipcode')}
          {editMode && <EditDataField field={poboxzipcodeField!} slideId={'addressOptions'} />}
        </div>
      </div>
    </div>
  );
};
